export const SUBSIDYTRANSACTIONCODES = [
  'REVPMT',
  'GOVTSUB',
  'PMTOTHER',
  'SUBTAKEBACK',
];
